module.exports = __webpack_public_path__ + "static/media/COG-OT-plus-logo.94116516.svg";